import { SiteToolScope } from "#app/sites/site-tool-scope";
import { createFileRoute, Link, Outlet, useRouterState } from "@tanstack/react-router";
import { ArrowLeft } from "lucide-react";
import { CapabilityGate } from "../../../components/capability-gate";

export const Route = createFileRoute("/_protected/sio-tools/_layout")({
  component: SioToolsLayout,
});

const SECTION_LABELS: Array<{ prefix: string; label: string }> = [
  { prefix: "/sio-tools/topics", label: "选题库" },
  { prefix: "/sio-tools/pipeline", label: "流水线" },
  { prefix: "/sio-tools/keywords", label: "关键词研究" },
  { prefix: "/sio-tools/ads", label: "广告投放" },
  { prefix: "/sio-tools/settings", label: "设置" },
  { prefix: "/sio-tools/insight", label: "Insight 共创" },
  { prefix: "/sio-tools/blog", label: "博客文章" },
  { prefix: "/sio-tools/external-links", label: "外链引用" },
];

/**
 * 推广工具布局（与建站工具对齐）：能力门禁 + 内容区。
 * Hub 即首页，不再保留顶部二级标签导航；子页顶部显示安静的返回链。
 */
function SioToolsLayout() {
  const pathname = useRouterState({ select: (s) => s.location.pathname });
  const isHub = pathname === "/sio-tools" || pathname === "/sio-tools/";
  const section = SECTION_LABELS.find((s) => pathname.startsWith(s.prefix));

  return (
    <CapabilityGate capability="sio-tools">
      <div className="min-h-screen bg-background">
        {!isHub && (
          <div className="border-border border-b bg-background">
            <div className="container mx-auto flex h-11 max-w-6xl items-center gap-2 px-4">
              <Link
                className="flex items-center gap-1.5 font-semibold text-[12.5px] text-ink-3 hover:text-ink"
                to="/sio-tools"
              >
                <ArrowLeft size={14} />
                推广工具
              </Link>
              {section && (
                <>
                  <span className="text-ink-3 text-xs">/</span>
                  <span className="font-semibold text-[12.5px] text-ink">{section.label}</span>
                </>
              )}
            </div>
          </div>
        )}
        <SiteToolScope home="/sio-tools">
          <Outlet />
        </SiteToolScope>
      </div>
    </CapabilityGate>
  );
}
